import {
  all,
  maxSlotMaxIndex,
  timeSlotsCeiling,
  timeSlotsFloor,
} from "@clockwise/client-commons/src/constants/time-slot";
import { DaySetting, Maybe, TimeSlot, WorkingHours } from "@clockwise/schema";
import { DateTime } from "luxon";

export function getEventMinMaxConstraints(
  meetingHourIntersection:
    | {
        start: string | null;
        end: string | null;
      }
    | undefined,
  workingHours: WorkingHours | undefined,
  date?: DateTime,
): [number, number] {
  // Get the min and max bounds of the move range. Either comes from suggestedAutopilotSettingsResponseV3 if present,
  // else the user's working hours for that day.
  let constraintMin = 0, // The earlist and latest time the range can be set to.
    constraintMax = maxSlotMaxIndex; // These are bad defaults. Something better.
  if (meetingHourIntersection) {
    constraintMin = meetingHourIntersection?.start
      ? timeSlotsFloor.indexOf(meetingHourIntersection.start)
      : constraintMin;
    constraintMax = meetingHourIntersection?.end
      ? timeSlotsCeiling.indexOf(meetingHourIntersection.end)
      : constraintMax;
  } else if (workingHours && date) {
    const selectedDay = date.toFormat("cccc"); // IE "Wednesday"

    const dayWorkingHours = workingHours?.daySettings?.find(
      (ds: Maybe<DaySetting>): ds is DaySetting => ds?.day === selectedDay,
    );

    if (dayWorkingHours) {
      // TODO (lsanwick) Remove MinSlot and MaxSlot from the schema. This type casting is because
      // MinSlot, MaxSlot, and TimeSlot are all identical enums, but Typescript doesn't know that.
      constraintMin = dayWorkingHours.setting?.minSlot
        ? all.indexOf((dayWorkingHours.setting.minSlot as unknown) as TimeSlot)
        : 0;
      constraintMax = dayWorkingHours.setting?.maxSlot
        ? all.indexOf((dayWorkingHours.setting.maxSlot as unknown) as TimeSlot)
        : maxSlotMaxIndex;
    }
  }

  return [constraintMin, constraintMax];
}
